import React from 'react'

import { useMediaQueryContext } from '@fourthwall/components'

import * as S from './styled'

type GroupTitleProps = {
  title: string
}

export const GroupTitle = ({ title }: GroupTitleProps) => {
  const media = useMediaQueryContext()

  return media.tablet ? <S.Title>{title}:</S.Title> : <S.Title>{title}</S.Title>
}
